"use client";

import { PorangeButton } from "@/components/atoms/PorangeButton";
import { Inter } from "next/font/google";
import classNames from "classnames";
import { TertiaryTitle } from "@/components/atoms/TertiaryTitle";
import ChargeInfoBox from "@/features/stripe-precheckout-payment-elements/ChargeInfoBox";
import PaymentElements from "@/features/stripe-precheckout-payment-elements/StripePaymentContainer";
import { Separator } from "@/components/atoms/Separator";
import { useStripeContext } from "@/context/StripeContextProvider";
import { PorangeCheckmark } from "@/components/atoms/PorangeCheckmark";

const inter = Inter({ subsets: ["latin"] });

export const PricingCard = ({
	title,
	features,
	price,
	buttonText,
	disclaimer,
	onClick,
	disabled = false,
	userEmail,
	branchUrl,
	onEmailChange,
	withTrial = false
}) => {
	const { stripeData } = useStripeContext();
	const { customerId } = stripeData;
	const isStripeEmbed = !!customerId;

	console.log('PricingCard', { stripeData });

	return (
		<div className="relative w-full p-[2px] bg-gradient-dark-porange rounded-[1.6rem] 
		shadow dark:text-blue-900">
			<div className="w-full py-5 sm:py-8 bg-white rounded-3xl">
				<div
					className={classNames(
						inter.className,
						"space-y-[16px] px-6 sm:px-10"
					)}>
					<TertiaryTitle>{title}</TertiaryTitle>
					<ul className="space-y-4 border-b pb-4">
						{features.map((feature, index) => (
							<li
								key={index}
								className="flex items-center gap-3">
								<PorangeCheckmark />
								<span className="text-navy-blue font-medium">{feature}</span>
							</li>
						))}
					</ul>

					<div className="space-y-2">
						<div className={classNames(
							"flex items-center gap-2 w-full font-bold text-[15px]",
							price ? "justify-between" : "justify-center text-center"
						)}>
							{isStripeEmbed ? null : <p className="">{disclaimer}</p>}
							{isStripeEmbed ? null : <h3 className="">{price}</h3>}
						</div>
						{isStripeEmbed ?
							<div className="my-4" id="card-payment-email">
								<ChargeInfoBox />
								<Separator text="Select payment method" />
								<PaymentElements
									withTrial={withTrial}
									branchUrl={branchUrl}
									userEmail={userEmail}
									onEmailChange={onEmailChange}
								/>
							</div>
							: (
								<PorangeButton
									showLoader
									disabled={disabled}
									onClick={onClick}
									className="h-14"
								>
									{buttonText}
								</PorangeButton>
							)}
						<div className="text-xs text-center">
							Cancel anytime, terms & conditions apply
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
